<button
  class="btn btn-primary d-flex align-items-center justify-content-center gap-2"
  [ngClass]="[signInClass() || '', isModal ? 'btn-block' : '']"
  (click)="login()"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 50 50"
    style="margin-right: 8px; vertical-align: middle"
  >
    <!-- Orange shield: top edge nearly horizontal -->
    <polygon fill="#EB5424" points="10,8 40,8 50,32 25,48 0,32" />
    <!-- White star, centered -->
    <polygon
      fill="#FFFFFF"
      points="
      25,14
      29,22
      39,22
      31,28
      34,36
      25,31
      16,36
      19,28
      11,22
      21,22
    "
    />
  </svg>
  <span translate>account.signin.auth0.button.label</span>
</button>

<!-- routerLink="/login" -->
<!-- [queryParams]="{ returnUrl: returnUrl }" -->
